export class Size {
    left: number;
    top: number;
    width: number;
    height: number;

    public constructor(left:number, top:number, width:number, height:number) {
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }

    get right(): number {
        return this.left + this.width;
    }

    get bottom(): number {
        return this.top + this.height;
    }
}


// WEBPACK FOOTER //
// ./src/app/Classes/sizeClass.class.ts